import actionTypes from 'redux/actionTypes';

export const setCaregiverZoneId = (zoneId: number) => (dispatch) => {
    dispatch({
        type: actionTypes.FILTER_CAREGIVER_ZONE_UPDATE,
        payload: { zoneId },
    });
};

export const setSortBy = (sortBy: string) => (dispatch) => {
    dispatch({
        type: actionTypes.SORT_BY_UPDATE,
        payload: { sortBy },
    });
};

export const setSortOrder = (sortOrder: string) => (dispatch) => {
    dispatch({
        type: actionTypes.SORT_ORDER_UPDATE,
        payload: { sortOrder },
    });
};
